<div class="layout-default">
  <div class="container-fluid page-container">
    <app-header></app-header>
    <div class="container">
      <app-sidebar></app-sidebar>
      
      <div class="main">
        <router-outlet></router-outlet>
      </div>
    </div>
    
    <app-footer></app-footer>
   
  </div>
</div>
